import { get, find } from 'lodash';
export var coalesceOn = function (obj, paths, subPaths) {
  var path = find(paths, function (item) {
    return !!find(subPaths, function (subPath) {
      return !!get(obj, "".concat(item, ".").concat(subPath));
    });
  });
  if (path) {
    return get(obj, path);
  }
  return null;
};